export default __webpack_public_path__ + "static/media/hht1_ep18_minisitcom_01.1758a3e9.png";